import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const pingdom = defineConnector({
  identifier: "pingdom",
  name: "Pingdom",
  tagLine: "Website monitoring and alerting",
  logo,
  protocol: "http",
  tags: ["observability"],
  defaultUrlPattern: () => "https://api\\.pingdom\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your API token",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to [Pingdom](https://my.pingdom.com/) and go to **Settings › Pingdom API** to generate a new API token.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.pingdom.com/api/3.1/checks",
  },
});
